import React, { useCallback, useMemo } from 'react';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import { StaticImage } from 'gatsby-plugin-image';
import './who.timeline.less';

const Timeline = () => {
  const { t } = useTranslation();
  const timeContent = useMemo(
    () => ({
      0: {
        when: t('web.about.timeline.date.one'),
        what: [
          {
            title: t('web.about.timeline.text.one'),
            subtitle: t('web.about.timeline.sub.text.one'),
          },
          {
            title: t('web.about.timeline.text.lidya'),
            subtitle: t('web.about.timeline.text.incorporation'),
            undersubtitle: t('ct_us'),
          },
          {
            title: t('web.about.timeline.text.lidya'),
            subtitle: t('web.about.timeline.text.start.operation'),
            undersubtitle: t('ct_ng'),
          },
          {
            title: t('web.about.timeline.text.first.loan'),
            subtitle: t('web.about.timeline.text.dispersed'),
          },
        ],
      },
      1: {
        when: t('web.about.timeline.date.two'),
        what: [
          {
            title: t('web.about.timeline.lidya.seed.round'),
          },
        ],
      },
      2: {
        when: t('web.about.timeline.date.three'),
        what: [
          {
            title: t('web.about.timeline.lidya.100.loans'),
            subtitle: t('web.about.timeline.text.disbursed'),
          },
        ],
      },
      3: {
        when: t('web.about.timeline.date.four'),
        what: [
          {
            title: t('web.about.timeline.text.lidya'),
            subtitle: t('web.about.timeline.tech.center'),
            undersubtitle: t('web.about.timeline.tech.country'),
          },
        ],
      },
      4: {
        when: t('web.about.timeline.date.five'),
        what: [
          {
            title: t('web.about.timeline.lidya.serie.a.round'),
          },
        ],
      },
      5: {
        when: t('web.about.timeline.date.six'),
        what: [
          {
            title: t('web.about.timeline.lidya.5000.loans'),
            subtitle: t('web.about.timeline.text.disbursed'),
          },
        ],
      },
      6: {
        when: t('web.about.timeline.date.seven'),
        what: [
          {
            title: t('web.about.timeline.lidya.10000.loans'),
            subtitle: t('web.about.timeline.text.disbursed'),
          },
          {
            title: t('web.about.timeline.text.lidya'),
            subtitle: t('web.about.timeline.text.incorporation'),
            undersubtitle: t('web.about.timeline.text.incorporation.ct_lu'),
          },
          {
            title: t('web.about.timeline.text.lidya'),
            subtitle: t('web.about.timeline.text.start.operation'),
            undersubtitle: t('web.about.timeline.text.incorporation.ct_cz'),
          },
          {
            title: t('web.about.timeline.text.lidya'),
            subtitle: t('web.about.timeline.text.start.operation'),
            undersubtitle: t('web.about.timeline.text.incorporation.ct_pl'),
          },
        ],
      },
    }),
    [],
  );

  const Content = useCallback(() => {
    return Object.values(timeContent).map((content, index) => (
      <React.Fragment key={index}>
        {content.what.map((what, nIndex) => (
          <div className="m-timeline__contentContainer" key={index + nIndex}>
            <span key={what.title}>
              <h1 className="a-timeline__title">{what.title}</h1>
              {what.subtitle ? (
                <p className="a-timeline__subtitle">{what.subtitle}</p>
              ) : null}
              {what.undersubtitle ? (
                <p className="a-timeline__undersubtitle">
                  {what.undersubtitle}
                </p>
              ) : null}
            </span>
          </div>
        ))}
        <time className="a-timeline__time">{content.when}</time>
      </React.Fragment>
    ));
  }, []);

  return (
    <div className="o-whoTimeline">
      <div className="m-globalContentContainer m-globalContentContainer__whoTimeline -block">
        <div className="m-whoTimeline__titleContainer">
          <h1 className="a-whoTimeline__title -page-title -centered">
            {t('web.about.timeline.title')}
          </h1>
        </div>
        <section className="timeline-mobile">
          <StaticImage
            src="../../../images/aboutUs/hor_timeline.svg"
            className="m-whoTimeline__svg -horizontal"
            alt={t('images.htimeline.alt')}
            title={t('images.htimeline.title')}
            objectFit="contain"
            width={1853}
            height={216}
          />
          <Content />
          <StaticImage
            src="../../../images/aboutUs/vert_timeline.svg"
            className="m-whoTimeline__svg -vertical"
            alt={t('images.vtimeline.alt')}
            title={t('images.vtimeline.title')}
            objectFit="contain"
            width={217}
            height={1718}
          />
        </section>
      </div>
    </div>
  );
};

export default Timeline;
